import { planTiers } from "@/react/helpers/planHelpers";

export const useShouldShowEnterprisePlusModal = (upgradeTier?: string) =>
  upgradeTier === planTiers.plus;
